'use strict';

export default function promiseImage(image) {
    if (image.tagName !== 'IMG') {
        throw new Error('promise-image must be given an IMG node');
    }
    return new Promise(function (resolve, reject) {
        if (image && image.complete && image.naturalWidth !== 0) {
            resolve(image);
        } else {
            image.addEventListener('load', function () {
                resolve(image);
            });
            image.addEventListener('error', function (e) {
                reject(e);
            });
        }
    });
}